import { toast } from "@heroui/react";

export const toastService = {
	success: (message: string) => toast.success(message),
	error: (message: string) => toast.danger(message),
};
